import { errorPlayerNotCreated, playOptions, } from './utils';
export const playerPlayProgram = (player, parameters) => {
    if (!player) {
        throw errorPlayerNotCreated;
    }
    return player.playProgram(parameters.cid, parameters.programId, playOptions(parameters.options));
};
